import { NdtStep } from "./helpers";

export default function() {
    return NdtStep('step2', 'Step 2: Once an employee has met the employment requirement, is the employee able to enter the Plan on or before the first day of the following plan year?', {
        nextComponent: () => 'step3'
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step2.js